import { Navigate, useParams } from 'react-router-dom';

export function LegacyCelebrationDashboardRedirect() {
  const { id } = useParams<{ id: string }>();

  if (!id) {
    return <Navigate to="/celebrations" replace />;
  }

  return <Navigate to={`/celebrations/${id}`} replace />;
}
